/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Icd10CodeRecordModelSearchResultModel } from '../../models/icd-10-code-record-model-search-result-model';
import { SearchRequestModel } from '../../models/search-request-model';

export interface Icd10CodeSearchIcd10CodePost$Params {
      body?: SearchRequestModel
}

export function icd10CodeSearchIcd10CodePost(http: HttpClient, rootUrl: string, params?: Icd10CodeSearchIcd10CodePost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Icd10CodeRecordModelSearchResultModel>> {
  const rb = new RequestBuilder(rootUrl, icd10CodeSearchIcd10CodePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Icd10CodeRecordModelSearchResultModel>;
    })
  );
}

icd10CodeSearchIcd10CodePost.PATH = '/ICD10Code/SearchICD10Code';
